export default "__VITE_ASSET__CamD1M1A__"